/**
 * Context to share Agora call state across the game component tree.
 * The provider lives in AVButton (which owns useAgoraCall),
 * and consumers like PlayerContainer read from it.
 */

import React, { createContext, useContext } from 'react'
import type { AgoraCallState, AgoraCallActions } from './types'

type AVContextValue = {
  state: AgoraCallState
  actions: AgoraCallActions
}

const defaultState: AgoraCallState = {
  isConnected: false,
  isPublishing: false,
  localMicEnabled: false,
  localCameraEnabled: false,
  remoteUsers: []
}

const defaultActions: AgoraCallActions = {
  join: () => {},
  leave: () => {},
  toggleMic: () => {},
  toggleCamera: () => {}
}

const AVContext = createContext<AVContextValue>({
  state: defaultState,
  actions: defaultActions
})

export function AVProvider({
  state,
  actions,
  children
}: AVContextValue & { children: React.ReactNode }) {
  return (
    <AVContext.Provider value={{ state, actions }}>
      {children}
    </AVContext.Provider>
  )
}

export function useAVContext(): AVContextValue {
  return useContext(AVContext)
}
